import React, { useState } from "react";
import { AddModal } from "components";
import { useAuth } from "hooks/useAuth";
import { formatUah } from "utils/format";

// Рівні оптових цін і стандартні націнки, % (мають збігатися з бекендом)
const TIERS = [
  { field: "markup_1", label: "Від 1 шт", defaultMarkup: 40 },
  { field: "markup_5", label: "Від 5 шт", defaultMarkup: 35 },
  { field: "markup_10", label: "Від 10 шт", defaultMarkup: 30 },
];

const formatPercent = (value) =>
  `${value.toLocaleString("uk-UA", { maximumFractionDigits: 2 })}%`;

// Модальне вікно індивідуальних оптових націнок товару.
// Порожнє поле означає стандартну націнку для цього рівня.
const WholesaleMarkupModal = ({ item, onSave, onClose }) => {
  const { isAllowed } = useAuth();
  const canViewPrices = isAllowed("recommendations:view-stocks");

  const [formState, setFormState] = useState(() =>
    TIERS.reduce((acc, { field }) => {
      const value = item.wholesale_markups?.[field];
      acc[field] = value === null || value === undefined ? "" : String(value);
      return acc;
    }, {}),
  );

  // Оптові ціни рахуються від закупу того ж типу оплати, що й у каталозі
  const purchasePrice =
    item.cash_quantity > 0 ? item.cash_purchase_price : item.debit_purchase_price;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // Скидає всі рівні до стандартних націнок
  const handleReset = () => {
    setFormState(Object.fromEntries(TIERS.map(({ field }) => [field, ""])));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const markups = TIERS.reduce((acc, { field }) => {
      acc[field] = formState[field] === "" ? null : parseFloat(formState[field]);
      return acc;
    }, {});

    onSave(item.article, markups);
    onClose();
  };

  return (
    <AddModal isOpen onClose={onClose} title={`Опт. націнка: ${item.article}`}>
      <form onSubmit={handleSubmit}>
        <div className="add-modal-body wholesale-markup-modal">
          {/* Рівні цін в один рядок: націнка, а під нею маржа й ціна */}
          {TIERS.map(({ field, label, defaultMarkup }) => {
            const markup =
              formState[field] === "" ? defaultMarkup : parseFloat(formState[field]);
            const isValid = !isNaN(markup) && markup >= 0;
            // Маржа — частка націнки в ціні продажу
            const margin = isValid ? (markup / (100 + markup)) * 100 : null;
            const showPrice = canViewPrices && purchasePrice > 0;

            return (
              <div className="wholesale-markup-modal__tier" key={field}>
                <label htmlFor={`wholesale-${field}`}>{label}</label>
                <input
                  id={`wholesale-${field}`}
                  name={field}
                  type="number"
                  min="0"
                  max="999.99"
                  step="0.01"
                  placeholder={defaultMarkup}
                  value={formState[field]}
                  onChange={handleChange}
                />
                <dl>
                  <div>
                    <dt>Маржа</dt>
                    <dd>{margin === null ? "---" : formatPercent(margin)}</dd>
                  </div>
                  {showPrice && (
                    <div>
                      <dt>Ціна</dt>
                      <dd>
                        {isValid
                          ? formatUah(Math.round(purchasePrice * (1 + markup / 100)))
                          : "---"}
                      </dd>
                    </div>
                  )}
                </dl>
              </div>
            );
          })}
        </div>

        <div className="add-modal-footer wholesale-markup-modal__footer">
          <button type="button" className="btn-cancel btn-reset" onClick={handleReset}>
            Стандартні
          </button>
          <button type="button" className="btn-cancel" onClick={onClose}>
            Відміна
          </button>
          <button type="submit" className="btn-save">
            Зберегти
          </button>
        </div>
      </form>
    </AddModal>
  );
};

export default WholesaleMarkupModal;
